
import { defineComponent } from "vue";
import { PLAY_STYLE_STRING } from "@/common/types/PlayStyle";

export default defineComponent({
  setup() {
    return {
      PLAY_STYLE_STRING,
    };
  },
});
